
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'ysh-flow-footer',
    templateUrl: './ysh-flow-footer.component.html',
    styleUrl: './ysh-flow-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule, MatTooltipModule]
})
export class YshFlowFooterComponent {

}
